export const lightTheme = {
    primary: {
        main: "#00925A",
        light: "#21C284",
        dark: "#0B4630",
    },
    secondary: "#2F4858",
    background: "#fbffff",
    text: {
        main: "#333",
        secondary: "#2F4858",
        aux: "#fff",
    },
    neutral: {
        light: "#f5f5f5",
        dark: "#171717",
    },
}

export const darkTheme = {
    primary: {
        main: "#00925A",
        light: "#21C284",
        dark: "#0B4630",
    },
    secondary: "#A2BDCD",
    background: "#202124",    
    text: {
        main: "#fff",
        secondary: "#A2BDCD",
        aux: "#fff",
    },
    neutral: {
        light: "#171717",
        dark: "#f9f9f9",
    },

}

